module.exports = __webpack_public_path__ + "img/source3_5.25740075.png";